module.exports = __webpack_public_path__ + "img/ocarina-of-time.2701edef.jpg";